/**
 * NOTES UTILS — helper puro per il campo `notes` del preventivo.
 *
 * La semantica di append è una sola, ovunque: newline separatrice se c'è già
 * testo, altrimenti la nota diventa il contenuto iniziale. Il `trim` della nota
 * è responsabilità del chiamante, così un Invio su textarea vuota non aggiunge
 * una riga bianca.
 */

export function appendNote(existing: string | null | undefined, note: string): string {
  return existing ? `${existing}\n${note}` : note;
}
